import Swiper from 'swiper/bundle';
import { Navigation } from "swiper/modules";
import type { Swiper as SwiperInstance } from 'swiper/types';

class MCLHeroSlider {
    sliderEl: HTMLElement;
    slider!: SwiperInstance;
    currentCount: NodeListOf<HTMLElement>;
    totalCount: NodeListOf<HTMLElement>;

    constructor(sliderEl: HTMLElement) {
        this.sliderEl = sliderEl;
        this.currentCount = this.sliderEl.querySelectorAll<HTMLElement>('.count-current');
        this.totalCount = this.sliderEl.querySelectorAll<HTMLElement>('.count-total');

        this.initSlider();
    }

    initSlider = (): void => {
        this.slider = new Swiper(this.sliderEl, {
            modules: [Navigation],
            autoplay: {
                delay: 5000,
            },
            effect: 'fade',
            loop: true,
            autoHeight: false,
            speed: 1250,
            fadeEffect: {
                crossFade: true,
            },
            lazyPreloadPrevNext: 10,
            navigation: {
                nextEl: '.mcl-hero-slider__btn.next',
                prevEl: '.mcl-hero-slider__btn.prev',
            },

            on: {
                init: this.onInit,
                realIndexChange: this.onRealIndexChange,
                // slideChangeTransitionEnd: this.onTransitionEnd
            }
        });
    };

    onInit = (swiper: SwiperInstance): void => {
        this.updateCount(this.totalCount, swiper.slides.length);
        this.updateCount(this.currentCount, swiper.realIndex + 1);

        // setTimeout(() => {
        //     this.animateCurrentSlide(swiper);
        // }, 500);
    };

    onTransitionEnd = (swiper: SwiperInstance) => {
        this.animateCurrentSlide(swiper);
    }

    onRealIndexChange = (swiper: SwiperInstance): void => {
        this.updateCount(this.currentCount, swiper.realIndex + 1);
    };

    animateCurrentSlide = (swiper: SwiperInstance) => {
        swiper.slides.forEach(s => s.classList.remove('animate'));
        const current = swiper.slides[swiper.activeIndex];
        current.classList.add('animate');
    }

    onClick = (swiper: SwiperInstance): void => {
        swiper.slideNext();
    };

    updateCount = (elements: NodeListOf<HTMLElement>, count: number): void => {
        elements.forEach(el => {
            el.textContent = count.toString();
        });
    };
}

export const mclHeroSliders = () => {
    const heroSliders = document.querySelectorAll('.mcl-hero-slider .swiper') as NodeListOf<HTMLElement>;

    if (heroSliders.length === 0) return;

    heroSliders.forEach(slider => new MCLHeroSlider(slider));
}